import script from "./Seismic_Parameters.vue?vue&type=script&setup=true&lang=js"
export * from "./Seismic_Parameters.vue?vue&type=script&setup=true&lang=js"

import "./Seismic_Parameters.vue?vue&type=style&index=0&id=825c3930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-825c3930"]])

export default __exports__